"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ERROR_NETWORK_CONNECTIVITY_message: 'Sorry, an unexpected error occurred while connecting to the server. Please check your network connectivity and try again.',
  ERROR_NETWORK_CONNECTIVITY_title: 'Network Connectivity Error',
  ERROR_NOT_FOUND_message: 'Sorry, the requested resource does not exist. Please check the URL and try again.',
  ERROR_NOT_FOUND_title: 'Not Found',
  ERROR_PERMISSION_DENIED_message: 'Sorry, you do not have permission to access the requested resource at this time. Please try again, or contact your administrator if the issue persists.',
  ERROR_PERMISSION_DENIED_title: 'Permission Denied',
  ERROR_UNEXPECTED_message: 'Sorry, an unexpected error occurred while processing your request. Please try again, or contact your administrator if the issue persists.',
  ERROR_UNEXPECTED_title: 'Unexpected Error'
};
exports.default = _default;